export const ONBOARDING_STEPS_TYPES = {
  START: 'start',
  ACTIVITY: 'activity',
  CHALLENGES: 'challenges',
  BEAUTY_ROUTINE: 'beautyRoutine',
  ACHIEVEMENTS: 'achievements',
  CUSTOMIZATION: 'customization',
  ROADMAP: 'roadmap',
  GAMES: 'games',
  RATING: 'rating',
  SHOPPING: 'shopping',
  SHELF: 'shelf',
  BOXES: 'boxes',
  PREM: 'prem',
  SHOP: 'shop',
};

export const ONBOARDING_MODAL_TYPES = {
  ONBOARDING_MODAL: 'onboardingModal',
  SLIDE_MODAL: 'slideModal',
};

export const ONBOARDING_BUTTON_CALLBACKS = {
  START: 'startOnboarding',
  UPDATE: 'updateOnboarding',
  RESET: 'resetOnboarding',
  SHOW_USER_MODALS: 'showUserModals',
  SHOW_ROADMAP: 'showRoadmap',
  SHOW_ACHIEVEMENTS_TAB: 'showAchievementsTab',
};

export const ONBOARDING_STORAGE_KEY = {
  DEFAULT: 'onboarding2026',
  MAY_2026: 'onboardingMay2026',
};

export const ONBOARDING_BUTTONS_CONDITION = {
  NOT_NEW_USER: 'not_new_user',
};

export const ONBOARDING_IMAGE_CONDITIONS = {
  HIDE_SECTIONS_2026_ME: 'hide_sections_2026_me',
  HIDE_SECTIONS_2026_CIS: 'hide_sections_2026_cis',
  HIDE_SECTIONS_2026_ME_RU: 'hide_sections_2026_me_ru',
  HIDE_SECTIONS_2026_ME_INTL: 'hide_sections_2026_me_intl',
};
